<script setup lang="ts">
  import SvgIcon from '@shared/components/svg-icon.vue'
  import type { INavigationList } from '@internal/types/navigation-list'
  import { ERouterList } from '@internal/router/constants/router-list'
  import { useUnreadMessagesStore } from '@/shared/store/unreadMessages'
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'

  defineProps<{
    item: INavigationList
  }>()
  const emit = defineEmits(['click'])
  const unreadMessagesStore = useUnreadMessagesStore()
  const { unreadMessagesByGroup } = storeToRefs(unreadMessagesStore)
  const totalUnreadMessages = computed(() => unreadMessagesByGroup.value.totalUnreadMessages)
</script>

<template>
  <li class="tw-mb-6">
    <router-link
      class="navigation-list-item tw-relative tw-flex tw-items-center tw-mx-10 tw-p-10 tw-text-grey-500 tw-rounded-4 tw-bg-transparent tw-transition-colors"
      :to="{ name: item.route, params: item.routeParams }"
      @click="emit('click')"
    >
      <span v-if="item.route === ERouterList.MESSAGING && totalUnreadMessages > 0" class="tw-relative">
        <svg-icon class="navigation-list-item__icon tw-mr-10 tw-fill-grey-500" :name="item.icon" />
        <span class="unread-count">{{ totalUnreadMessages }}</span>
      </span>
      <svg-icon v-else class="navigation-list-item__icon tw-mr-10 tw-fill-grey-500" :name="item.icon" />
      <span class="tw-text-subtitle-1">{{ item.name }}</span>
    </router-link>
  </li>
</template>

<style scoped lang="scss">
  .navigation-list-item {
    $this: &;
    &::before {
      content: '';
      @apply tw-absolute -tw-left-10 tw-block tw-w-2 tw-h-full tw-bg-transparent tw-rounded-2 tw-transition-colors;
    }
    &:hover,
    &.router-link-exact-active {
      @apply tw-text-white tw-bg-grey-110;
      &::before {
        @apply tw-bg-white;
      }
    }
  }
  .unread-count {
    position: absolute;
    top: -35%;
    right: 0;
    background-color: #ff7576;
    color: white;
    border-radius: 100%;
    padding: 2px 4px;
    font-size: 12px;
    min-width: 20px;
    text-align: center;
  }
</style>
